module.exports = __webpack_public_path__ + "static/media/aviso.c676b2ff.pdf";